import { SORTING_DIRECTION } from 'src/constants/main';
import { IAllBranchesModalItem } from 'src/view/containers/Modals/AllBranchesModal/AllBranchesModal';
import { ICategoryOrProductItem } from 'src/view/containers/Modals/CategoryAndProductModal/CategoryAndProductModal';
import { ICustomersModalItem } from 'src/view/containers/Modals/CustomersModal/types';
import { DAYS_OF_WEEK } from '~/constants/dateTime';
import { TTranslate } from '~/types/main';

export type TPromocode = {
  id: number;
  promocode: string;
  delivery_types: PROMOCODE_DELIVERY_TYPE[]; // IS_ALL: 0, IS_DELIVERY: 1, IS_PICKUP: 2, IS_CURBSIDE: 3
  provide_as: PROMOCODE_PROVIDE_AS;
  branches: IAllBranchesModalItem[]; // list of branches ids or empty array
  customers: ICustomersModalItem[]; // list of users ids or empty array
  products: ICategoryOrProductItem[] | null; // list of products or empty array
  categories: ICategoryOrProductItem[] | null; // list of categories or empty array
  amount: number; // min 0,
  start_date: string; // in Y-m-d format,
  end_date: string; // in Y-m-d format after date_start,
  discount_type: PROMOCODE_DISCOUNT_TYPE; // in [a - amount, p - percentage],
  is_all_day: boolean;
  user_limited?: number; // min 0,
  usage_limited?: number; // min 0,
  is_free_delivery?: boolean;
  first_order?: boolean;
  applicability: PROMOCODE_APPLICABILITY; // in [0 - all, 1 - orders],
  minimum_order?: number; // min 0,
  max_discount_amount?: number | null; // min 0 ony if `discount_type` is `p`,
  menu: PROMOCODE_MENU; // [0 - all, 1 - include, 2 - exclude],
  start_time?: string | null; // in H:m format only if is_all_day - false,
  end_time?: string | null; // in H:m format only if is_all_day - false,
  days_of_week?: DAYS_OF_WEEK[]; // Week days from 1 - monday to 7 - Sunday
  external_id: string | number;
  reoccurring_usage_limited?: 0 | 1 | null;
  reoccurring_usage_interval_type?: 0 | 1 | null;
  usage_number_per_interval?: number | null; // min 0,
  usage_interval?: number | null;
  is_shown_as_offer?: boolean;
  description: TTranslate;
};

export interface IEditPromocode {
  promocode?: string; // Unique in promocodes table, except current one,
  amount?: string; // float number, min 0
  start_date?: Date; // in Y-m-d format,
  end_date?: Date; // in Y-m-d format after date_start,
  discount_type?: PROMOCODE_DISCOUNT_TYPE; // in [a - amount, p - percentage],
  provide_as?: PROMOCODE_PROVIDE_AS;
  is_all_day?: boolean;
  delivery_types?: PROMOCODE_DELIVERY_TYPE[]; // IS_ALL: 0, IS_DELIVERY: 1, IS_PICKUP: 2, IS_CURBSIDE: 3
  //
  products?: ICategoryOrProductItem[];
  categories?: ICategoryOrProductItem[];
  user_limited?: number; // min 0,
  reoccurring_usage_limited?: 0 | 1 | null;
  reoccurring_usage_interval_type?: 0 | 1 | null;
  usage_number_per_interval?: number | null; // min 0,
  usage_interval?: number | null;
  usage_limited?: number; // min 0,
  is_free_delivery?: boolean;
  first_order?: boolean;
  applicability?: PROMOCODE_APPLICABILITY; // in [0 - all, 1 - orders],
  minimum_order?: string; // float number, min 0
  max_discount_amount?: string; // float number, min 0 ony if `discount_type` is `p`
  menu?: PROMOCODE_MENU; // in [0 - all,1 - include, 2 - exclude],
  customers?: ICustomersModalItem[];
  branches?: IAllBranchesModalItem[];
  start_time?: Date | null; // in H:m format only if is_all_day - false,
  end_time?: Date | null; // in H:m format only if is_all_day - false,
  days_of_week?: DAYS_OF_WEEK[]; // Week days from 1 - monday to 7 - Sunday
  external_id?: number | string;
  description?: TTranslate;
  //
  allBranches?: boolean;
  allCustomers?: boolean;
  is_shown_as_offer?: boolean;
}

export interface IPromocodesFilter {
  name?: string;
  sort_field?: PROMOCODE_SORT_COLUMN; // Any of promocodes field
  sort_dir?: SORTING_DIRECTION; // ASC or DESC
}

export enum PROMOCODE_DISCOUNT_TYPE {
  AMOUNT = 'a',
  PERCENTAGE = 'p',
}

export enum PROMOCODE_PROVIDE_AS {
  DISCOUNT = 'discount',
  CASHBACK = 'cashback',
}

export enum PROMOCODE_DELIVERY_TYPE {
  ALL,
  IS_DELIVERY,
  IS_PUCKUP,
  IS_CURBSIDE,
  IS_DINEIN,
}

export enum PROMOCODE_APPLICABILITY {
  ALL,
  ORDERS,
}

export enum PROMOCODE_MENU {
  ALL,
  INCLUDE,
  EXCLUDE,
}

export enum PROMOCODE_SORT_COLUMN {
  NAME = 'promocode',
  DISCOUNT_TYPE = 'discount_type',
  AMOUNT = 'amount',
  START_DATE = 'start_date',
  EXPIRY_DATE = 'expiry_date',
  MIN_ORDER = 'minimum_order',
}

export interface IPromocodesIsValid {
  promocode: boolean;
  amount: boolean;
  max_discount_amount: boolean;
  start_date: boolean;
  end_date: boolean;
  discount_type: boolean;
  delivery_types: boolean;
  menu: boolean;
  all: boolean;
}

export interface IPromocodeValidationErrors {
  descriptionEn: string | null;
  descriptionAr: string | null;
}
